import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ToasterService {
  private showAlertSubject = new Subject<{ message: string, type: string }>();

  showAlert$ = this.showAlertSubject.asObservable();

  triggerAlert(message: string, type: string) {
    this.showAlertSubject.next({ message, type });
  }
}
